import React from "react";
import { InfrastructureDetails } from "../redux";
import Details from "../details";
import DetailsList from "../details-list";
import { TeamType } from "../../../create-team/redux";
import NeoLink from "../../../../common/components/neo-link";
import SensibleDefaultBadge from "../../../../common/components/sensible-default-badge";
import "./circle-ci-info.scss";

type Props = Pick<InfrastructureDetails, "ciCdProvider" | "pipelines" | "githubOrg"> & {
  teamType: TeamType;
};

const CircleCiInfo = (props: Props) => {
  const pipelines = props.pipelines ?? [];

  // Mirrors the `.api-detail-status { display: flex; align-items: center; }` pattern used to
  // align the "Healthy" status pill with the API name on the API detail page - keeps the badge
  // vertically centred against the "CircleCI" text like a postfix, rather than a separate line.
  const renderCircleCiFieldName = () => (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      CircleCI
      <SensibleDefaultBadge />
    </span>
  );

  const renderCiCdDetailsForExperimentsAndInnovation = () => (
    <DetailsList
      fieldName={props.ciCdProvider ?? renderCircleCiFieldName()}
      detailsList={pipelines}
      renderUrlsAsHyperLink={true}
    />
  );

  const renderCircleCiDocLink = () => (
    <NeoLink
      className="circle-ci-link"
      link="https://docs.google.com/document/d/1xJFi9Vc47jlg9oFROjEPWlK01-HnjUh7qU1jI8irbZE/edit"
      label="here"
      external
    />
  );

  const renderCreateCircleCIAccountDocumentationLink = () => (
    <>
      <Details
        fieldName={renderCircleCiFieldName()}
      >
        {
          props.githubOrg
          && (
            <>
              Click
              {" "}
              {renderCircleCiDocLink()}
              {" "}
              to know how to integrate the repositories with the pipeline or to upgrade the CircleCI plan.
            </>
          )
        }
      </Details>
    </>
  );

  function renderContent() {
    if (
      props.teamType === TeamType.EXPERIMENT_AND_INNOVATION
      || props.teamType === TeamType.GITS
    ) {
      return renderCiCdDetailsForExperimentsAndInnovation();
    }
    return renderCreateCircleCIAccountDocumentationLink();
  }

  return (
    <div className="CircleCiInfo">
      {renderContent()}
    </div>
  );
};

export default CircleCiInfo;
